// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Kb9B","title":"Info_title__1ETVy","selects":"Info_selects__1HLyj","requiredAsterisk":"Info_requiredAsterisk__XN2KU"};